module.exports = __webpack_public_path__ + "static/why-5b795d8dc3db300e504d914866fc585a.jpg";